import * as React from 'react';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var SuggestItemLeftIcon = function SuggestItemLeftIcon(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles['icon'],
    children: props.children
  });
};